export enum UsersRouteName {
    Users = 'users',
    Geolocation = 'users-geolocation',
    Analytic = 'users-analytic'
}
